import type { FC, ReactNode } from 'react';
import { IonContent, IonPage, IonSpinner } from '@ionic/react';
import { Navigate } from 'react-router-dom';
import { useUserAccount } from '../../hooks/useUserAccount';
import { hasAdminRole } from './adminAccess';

interface AdminGuardProps {
  children: ReactNode;
}

export const AdminGuard: FC<AdminGuardProps> = ({ children }) => {
  const { userAccount, loading } = useUserAccount();

  if (loading) {
    return (
      <IonPage>
        <IonContent className="ion-padding">
          <div className="flex min-h-[200px] items-center justify-center">
            <IonSpinner name="crescent" />
          </div>
        </IonContent>
      </IonPage>
    );
  }

  if (!hasAdminRole(userAccount?.roles)) {
    return <Navigate to="/app/main/perfil" replace />;
  }

  return <>{children}</>;
};
